export default "__VITE_ASSET__dae3b87f__"